module.exports = __webpack_public_path__ + "static/icon-8877ec5f2e43e6617992e6c22ad7c6c9.png";